import type { CSSProperties, MouseEvent as ReactMouseEvent, ReactNode } from 'react'
import { ChevronDownIcon, ChevronUpDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline'
import { ColumnResizeHandle, type SortDirection } from '@/tableControls'

export function FixedAssetsSortableHeader({
  label,
  sortKey,
  sortDirection,
  onSort,
  className = '',
  title,
  columnKey,
  style,
  onStartResize,
  showResize = true,
}: {
  label: ReactNode
  sortKey: string
  sortDirection: SortDirection | null
  onSort: (key: string) => void
  className?: string
  title?: string
  columnKey: string
  style?: CSSProperties
  onStartResize?: (key: string, event: ReactMouseEvent) => void
  showResize?: boolean
}) {
  const isSorted = sortDirection !== null

  return (
    <th
      className={`sortable relative ${isSorted ? 'sorted' : ''} ${className}`}
      style={style}
      title={title}
      onClick={() => onSort(sortKey)}
    >
      <span className="inline-flex items-center gap-1 pr-2">
        {label}
        <span className="sort-indicator">
          {sortDirection === 'asc' ? (
            <ChevronUpIcon className="h-3 w-3" />
          ) : sortDirection === 'desc' ? (
            <ChevronDownIcon className="h-3 w-3" />
          ) : (
            <ChevronUpDownIcon className="h-3 w-3" />
          )}
        </span>
      </span>
      {showResize && onStartResize ? (
        <ColumnResizeHandle columnKey={columnKey} onStartResize={onStartResize} />
      ) : null}
    </th>
  )
}
